import React, { useState, useEffect } from "react";
import MaterialTable from "material-table";
import { Grid, Typography, SvgIcon, ListSubheader } from "@material-ui/core";
import tableIcons from "../../components/TableIcon";
import ListAltIcon from '@material-ui/icons/ListAlt';
import krLoacale from "date-fns/locale/ko";
import calStore from "../../stores/calculateStore";
import hisStore from "../../stores/calHistoryStore";
import Moment from "moment";

const calCol = () => [
  {
    title: "작성일자",
    field: "date",
    type: "date",
    defaultSort: "desc",
    cellStyle: { 
      // Color: '#0000000', fontWeight: "normal"
    },
    // render: rowData => {
    //   return <i style={{ Color: '#000000', fontStyle: 'normal', fontWeight: "normal" }}>{Moment(rowData.date).format('YYYY. MM. DD')}</i>
    // },
    // initialEditValue: Moment()
  },
  {
    title: "항목",
    field: "desc",
    sorting: false,
    // lookup: { '우편': '우편', '식대': '식대', '정수기 청소': '정수기 청소' },
    cellStyle: {
    },
  },
  {
    title: "비고",
    field: "postscript",  
    sorting: false,
    cellStyle: {
      color: '#002984',
      fontStyle: 'italic'
    }
  },
  {
    title: "담당자",
    field: "name",
    editable: "never",
    sorting: false,
    cellStyle: {
    }
  },
  {
    title: "수입 및 지출",
    field: "expense",
    sorting: false,
    cellStyle: {
      backgroundColor: '#ffcdd2',
    },
    render: rowData => {
      return rowData.expense.includes('+') ? <i style={{ fontStyle: "normal" }}>{rowData.expense}</i> : <i style={{ fontStyle: "normal", color: '#ba000d', fontWeight: "bold"}}>{rowData.expense}</i>
    },
  },
  {
    title: "잔액",
    field: "remain",
    type: "numeric",
    editable: "never",
    sorting: false,
    cellStyle: {
      // width: 20
      // backgroundColor: '#039be5',
      // color: '#800000'
      // color: '#039be5',
    },
    // render: rowData => {
    //   const cnt = rowData.tableData.id;

    //   return rowData.tableData.id === cnt? <i style={{ fontStyle: "normal", color: '#039be5', fontWeight: "bold"}}>{rowData.remain}</i> : <i style={{ fontStyle: "normal"}}>{rowData.remain}</i>
    // }
  }
];

function DataTable(props) {
  const user = props.user;
  const list = props.list;
  const noEdit = props.noEdit;
  const lastHisDate = props.lastHisDate;
  const datelist = props.datelist;
  const lastDay = props.lastDay;
  // var Remain = props.list[list.length-1].remain;

  return (
      <Grid container spacing={1}>
      <Grid item xs={12}>
        {/* <Typography variant="h6" color="primary">{Remain}</Typography> */}
        <MaterialTable
          // stickyHeader 
          title="잡비 사용 내역"
          icons={tableIcons}
          data={list}
          columns={calCol()}

          localization={{
              header: {
                  actions: "편집",
                },
            body: {
                editRow: {
                    saveTooltip: "저장",
                    cancelTooltip: "취소",
                    deleteText: "정말 삭제하시겠습니까?"
              },
              editTooltip: "수정",
              deleteTooltip: "삭제",
              addTooltip: "추가",
              dateTimePickerLocalization: krLoacale,
            }
          }}
          actions={[
            // {
            //   icon: () => (
            //     <Typography varient="button" variant="button" color="secondary"> </Typography>
            //     // <Typography varient="button" variant="button" color="secondary">현 잔액: {list[list.length-1].remain}</Typography>
            // ),
            // tooltip: "현 잔액",
            // position: "toolbar",
            // onClick: () => {
            //   try {
            //     alert(String(list[list.length-1].remain + "원"))
            //     // Remain = list[list.length-1].remain + "원";
            //     // console.log(Remain);
            //   } catch(e) {
            //     alert("0원")
            //   }
            // } 
            // },
            {
              icon: ListAltIcon,
              position: "toolbar",
              tooltip: "정산하기",
              onClick: () => {
                // eslint-disable-next-line no-restricted-globals
                let result = confirm("정산하시겠습니까?");//+ 'lastday: '+ lastDay + 'lastHisDate' + Moment(lastHisDate).format('YYMMDD') + 'datelist[0]: ' + Moment(datelist[0]).format('YYMMDD'));
                if(result) {  //lasthisdate = 정산되지 않은 데이터중 가장 최신데이터의 마지막 날짜 //lastDay: 가장 최신의 정산기록 마지막날짜
                  if(lastDay) {
                    if(Moment(lastDay).format('YYMMDD') === Moment(datelist[0]).format('YYMMDD')){
                      hisStore.addHistory(noEdit)
                      alert('정산되었습니다. \'잡비 정산 기록\' 탭에서 확인해주세요.');
                    } else if(Moment(datelist[0]).format('DD') === Moment().date('01').format('DD')) {
                      hisStore.addHistory(noEdit)
                      alert('정산되었습니다. \'잡비 정산 기록\' 탭에서 확인해주세요.');
                    } else {
                      alert(Moment(datelist[0]).format('DD') +'||'+ Moment().date('01').format('DD'));
                      alert('지난 정산 날짜는 '+ Moment(lastDay).format('YYYY년 MM월 DD일') + '입니다. 시작날짜를 ' + Moment(lastDay).format('YYYY년 MM월 DD일') + '로 설정바랍니다.');
                    }
                  } else {
                      if(Moment(lastHisDate).format('YYMMDD') === Moment('1000-10-10').format('YYMMDD')){
                        hisStore.addHistory(noEdit)
                        alert('정산되었습니다. \'잡비 정산 기록\' 탭에서 확인해주세요.');
                      } else {
                        alert('지난 정산 날짜는 '+ Moment(lastHisDate).format('YYYY년 MM월 DD일') + '입니다. 시작날짜를 ' + Moment(lastHisDate).format('YYYY년 MM월 DD일') + '로 설정바랍니다.');
                      }
                    }
                } else alert('정산이 취소되었습니다.');

              }
              
            },
        ]}
        options={{
          search: false,
          // editCellStyle: { backgroundColor: '#3f51b5',},   //수정시 저장, 삭제 셀 배경
          pageSize: 15,
          pageSizeOptions: [10, 15, 20, 30],
          thirdSortClick: false,
          // doubleHorizontalScroll: true, //칼럼 개수가 늘어나면 사용
          headerStyle: header => ({
            backgroundColor: '#FFF',
          }),
          // cellStyle : rowData => {
          //   if(rowData.tableData.id === list.length-1)
          //     return { fontStyle: "normal", color: '#039be5', fontWeight: "bold"}
          // }
          // rowStyle: rowData => {
          //   if(rowData.tableData.id === list.length-1)
          //     // return { backgroundColor: '#039be5', fontWeight: "bold"}
          //     return <i style={{ fontStyle: "normal", color: '#039be5', fontWeight: "bold"}}>{rowData.remain}</i>
          // }
        }}
        editable={{
            isEditable: (noEdit === 0 ? rowData=> rowData: rowData => rowData.date > lastHisDate), 
            isDeletable: (noEdit === 0  ? rowData=> rowData: rowData => rowData.date > lastHisDate),
            onRowAdd: (newData, oldData) =>
            new Promise((resolve, reject) => {
                (async () => {
                  try {
                    if(!newData.date) {
                      newData.date = Moment().format();
                    }
                    if(Moment(Number(newData.date)).format() < lastHisDate){
                      throw SyntaxError(lastHisDate + '정산이 끝난 날짜 범위에는 데이터를 추가할 수 없습니다');
                    } 
                    // else if(String(newData.expense).includes('+')) {
                    //   if((Number(String(list[list.length-1].remain).replace(",","")) + Number(String(newData.expense).replace("+","").replace(",",""))) > 500000) {
                    //     throw SyntaxError('잔액은 50만원을 초과할 수 없습니다');
                    //   }
                    // } 
                    else {
                      newData.name = user.username;
                      await calStore.addCalculate(newData);
                      resolve();
                    }
                  } catch (e) {
                      alert(e.message);
                      resolve();
                    }
                })();
            }),
            onRowUpdate: (newData, oldData) =>
              new Promise(resolve => {
                (async () => {
                  try {
                      await calStore.updateCalculate(newData);
                      resolve();
                    } catch (e) {
                        alert(e.message);
                  resolve();
                }
            })();
        }),
            onRowDelete: (newData, oldData) => 
              new Promise((resolve) => {
                (async () => {
                  try {
                    await calStore.deleteCalculate(newData._id);
                    resolve();
                  } catch (e) {
                    alert(e.message);
                    resolve();
                  }
                })();
              })
          }}
        />
      </Grid>
    </Grid>
  );
}

export default DataTable;